import { applyTokens } from "../../../utilities/applyTokens.js";
const dialog = (tokens) => {
    const { component: { modal }, core, } = tokens;
    const { header, content, footer } = modal;
    return {
        MuiDialog: {
            styleOverrides: {
                paper: {
                    borderRadius: modal.borderRadius.value,
                    boxShadow: modal.boxShadow.value.stringValue,
                    padding: 0,
                    maxWidth: modal.maxWidth.value,
                    width: modal.maxWidth.value,
                    backgroundColor: modal.backgroundColor.value,
                    color: modal.color.value,
                },
                paperFullScreen: {
                    maxWidth: "100%",
                    width: "100%",
                },
            },
        },
        MuiDialogTitle: {
            styleOverrides: {
                root: Object.assign(Object.assign({}, applyTokens(header)), { display: "flex", alignItems: "center", justifyContent: "space-between", wordBreak: "break-word", ".MuiButtonBase-root svg": Object.assign({}, applyTokens(header.icon)) }),
            },
        },
        MuiDialogContent: {
            styleOverrides: {
                root: Object.assign({}, applyTokens(content)),
            },
        },
        MuiDialogContentText: {
            styleOverrides: {
                root: {
                    color: content.color.value,
                },
            },
        },
        MuiDialogActions: {
            styleOverrides: {
                root: Object.assign(Object.assign({}, applyTokens(footer)), { gap: footer.gap.value, ".MuiFormControlLabel-root": {
                        margin: core.spacing[0].value,
                        gap: footer.checkbox.gap.value,
                    }, "> div:has(.MuiButton-root + .MuiButton-root)": {
                        display: "flex",
                        gap: footer.gap.value,
                    } }),
            },
        },
        MuiBackdrop: {
            styleOverrides: {
                root: {
                    "&:not(.MuiBackdrop-invisible)": {
                        backgroundColor: modal.backdrop.backgroundColor.value,
                    },
                },
            },
        },
    };
};
export default dialog;
//# sourceMappingURL=dialog.js.map